import { AccountListItemDto } from '../dto/account-list-item-dto';
import { SupplierListItem } from '../supplier-list-item';
import { mapAddress } from './address-mapper';

export const mapSupplierListItem = (supplier: AccountListItemDto): SupplierListItem => ({
    id: supplier.id,
    name: supplier.name,
    image: supplier.image,
    email: supplier.email,
    phone: supplier.phone,
    address: mapAddress(supplier.address),
    isChargingSupplier: supplier.isChargingSupplier,
    classification: supplier.classification,
});
